module.exports = __webpack_public_path__ + "img/target-3.7e70d4ac.png";